import React from 'react';

import Editor from 'components/Editor';

import { useExamStudentStore } from 'store/exam/useExamStudentStore';

const Term = ({ connection }) => {
	// Use exam's student store
	const slug = useExamStudentStore(state => state.exam.slug);

	return (
		<div className="flex items-center space-x-2">
			<div className="text-2xl font-bold text-neutral-700 dark:text-white">
				{connection.name}
			</div>

			<div className="flex-1">
				<Editor
					readOnly
					path="exams"
					folder={slug}
					value={connection.answer}
				/>
			</div>
		</div>
	);
};

export default Term;